import { ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/dropdown-helper.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../directives/disabled/disabled.directive";
import * as i4 from "@angular/forms";
import * as i5 from "../../modals/help-modal/components/help-modal.component";
import * as i6 from "../../../directives/icon/icon.directive";
const _c0 = ["multiSelectDropdown"];
const _c1 = a0 => ({ show: a0 });
const _c2 = (a0, a1) => ({ "custom-checkbox-tall": a0, "pr-2": a1 });
const _c3 = a0 => ({ "mr-12": a0 });
function MultiSelectDropdownComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.dropdownItemClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r1.configCopy.title.label, "", (ctx_r1.configCopy == null ? null : ctx_r1.configCopy.title == null ? null : ctx_r1.configCopy.title.value) ? ": " : "");
} }
function MultiSelectDropdownComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8)(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configCopy == null ? null : ctx_r1.configCopy.title == null ? null : ctx_r1.configCopy.title.value);
} }
function MultiSelectDropdownComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r1.countSelected, ") ");
} }
function MultiSelectDropdownComponent_div_8_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} }
function MultiSelectDropdownComponent_div_8_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", listItem_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", listItem_r4.description);
} }
function MultiSelectDropdownComponent_div_8_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, listItem_r4.icon))("textContent", listItem_r4.label);
} }
function MultiSelectDropdownComponent_div_8__svg_svg_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 23);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", listItem_r4.icon);
} }
function MultiSelectDropdownComponent_div_8_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵlistener("click", function MultiSelectDropdownComponent_div_8_ng_container_8_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r5); const listItem_r4 = i0.ɵɵnextContext().$implicit; i0.ɵɵnextContext(); const helpModal_r6 = i0.ɵɵreference(10); helpModal_r6.openModal(listItem_r4.helpName); return i0.ɵɵresetView(false); });
    i0.ɵɵtext(4, "(?)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function MultiSelectDropdownComponent_div_8_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} }
function MultiSelectDropdownComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵconditionalCreate(1, MultiSelectDropdownComponent_div_8_Conditional_1_Template, 1, 0, "div", 11);
    i0.ɵɵelementStart(2, "label", 12)(3, "input", 13);
    i0.ɵɵlistener("change", function MultiSelectDropdownComponent_div_8_Template_input_change_3_listener() { const listItem_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleChange(listItem_r4)); });
    i0.ɵɵtwoWayListener("ngModelChange", function MultiSelectDropdownComponent_div_8_Template_input_ngModelChange_3_listener($event) { const listItem_r4 = i0.ɵɵrestoreView(_r3).$implicit; i0.ɵɵtwoWayBindingSet(listItem_r4.selected, $event) || (listItem_r4.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 14);
    i0.ɵɵtemplate(5, MultiSelectDropdownComponent_div_8_span_5_Template, 3, 2, "span", 15)(6, MultiSelectDropdownComponent_div_8_span_6_Template, 1, 4, "span", 16)(7, MultiSelectDropdownComponent_div_8__svg_svg_7_Template, 1, 1, "svg", 17)(8, MultiSelectDropdownComponent_div_8_ng_container_8_Template, 5, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MultiSelectDropdownComponent_div_8_div_9_Template, 1, 0, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(listItem_r4.dividerAbove ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", listItem_r4.disabled)("ngClass", i0.ɵɵpureFunction2(9, _c2, listItem_r4.description, listItem_r4.icon));
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", listItem_r4.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", listItem_r4.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !listItem_r4.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.helpName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.dividerUnder);
} }
/**
 * Multi-Select Dropdown Component
 *
 * This component shows a list of items and checkboxes in dropdown. The checkboxes show whether or not
 * The corresponding item is currently selected.
 *
 * Input Properties:
 *      buttonClass: string that is the CSS class to apply to the button that opens the dropdown
 *      config: MultiSelectDropdownConfig which has the dropdown title and list of items to be in the dropdown
 *      dropdownClass: string that is The CSS class to be applied to the dropdown menu itself
 *
 * Output Properties:
 *      changeHandler: EventEmitter that emits the item whenever an item is selected or deselected
 *      changeHandlerAll: EventEmitter that emits the list of all items whenever a change is detected
 *      closeHandler: EventEmitter that emits whenever the dropdown is closed
 *
 * Internal Properties:
 *      isOpen: boolean for whether or not the dropdown is display the selectable items
 *      countSelected: number that represents the count of items in the dropdown that are currently selected
 */
export class MultiSelectDropdownComponent {
    constructor(dropdownHelperService) {
        this.dropdownHelperService = dropdownHelperService;
        this.changeHandler = new EventEmitter();
        this.changeHandlerAll = new EventEmitter();
        this.closeHandler = new EventEmitter();
        this.isOpen = false;
        this.countSelected = 0;
    }
    ngOnInit() {
        this.setSelectAllStatus(this.allItemsAreSelected());
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.toggle();
            }
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement, autoCloseHandler);
    }
    ngOnChanges(changes) {
        if (changes.config?.currentValue) {
            this.configCopy = { ...changes.config.currentValue };
        }
        this.countSelected = this.configCopy.list.filter((item) => item.selected).length;
    }
    toggle() {
        if (!this.inputDisabled) {
            if (this.isOpen) {
                this.isOpen = false;
                this.closeHandler.emit();
            }
            else {
                this.isOpen = true;
            }
        }
        else {
            this.isOpen = false;
        }
    }
    allItemsAreSelected() {
        const allSelectableItems = this.config.list.filter((item) => !item.selectAll);
        const selectedSelectableItems = this.config.list.filter((item) => item.selected && !item.selectAll);
        return allSelectableItems.length === selectedSelectableItems.length;
    }
    setAllItemsSelectedStatus(status) {
        this.config.list.forEach((item) => {
            item.selected = !!status; // eslint-disable-line no-param-reassign
        });
    }
    setSelectAllStatus(status) {
        this.config.list.forEach((item) => {
            if (item.selectAll)
                item.selected = !!status; // eslint-disable-line no-param-reassign
        });
    }
    handleChange(item) {
        if (item.selectAll) {
            if (item.selected) {
                // select all items
                this.setAllItemsSelectedStatus(true);
                this.countSelected = this.configCopy.list.length;
            }
            else {
                // de-select all items
                this.setAllItemsSelectedStatus(false);
                this.countSelected = 0;
            }
        }
        else {
            this.countSelected = item.selected ? this.countSelected + 1 : this.countSelected - 1;
            if (item.selected && this.allItemsAreSelected()) {
                this.setSelectAllStatus(true);
            }
            if (!item.selected) {
                this.setSelectAllStatus(false);
            }
        }
        this.changeHandler.emit(item);
        this.changeHandlerAll.emit(this.config.list);
    }
}
MultiSelectDropdownComponent.ɵfac = function MultiSelectDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiSelectDropdownComponent)(i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
MultiSelectDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiSelectDropdownComponent, selectors: [["ycn-multi-select-dropdown"]], viewQuery: function MultiSelectDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, inputs: { buttonClass: "buttonClass", config: "config", dropdownClass: "dropdownClass", dropdownContainerClass: "dropdownContainerClass", dropdownItemClass: "dropdownItemClass", inputDisabled: "inputDisabled" }, outputs: { changeHandler: "changeHandler", changeHandlerAll: "changeHandlerAll", closeHandler: "closeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 11, vars: 20, consts: [["multiSelectDropdown", ""], ["helpModal", ""], [3, "ngClass"], ["ycnDisabled", "", "href", "javascript:void(0)", 3, "click", "disabled"], [3, "class", 4, "ngIf"], ["class", "text-default", 4, "ngIf"], ["class", "mr-1", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "text-default"], [1, "text-gray-40"], [1, "mr-1"], [1, "dropdown-divider"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", "dropdown-item", 3, "disabled", "ngClass"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "ngModel"], [1, "custom-control-indicator"], ["class", "custom-control-description dropdown-item-text", 4, "ngIf"], ["class", "custom-control-description", 3, "ngClass", "textContent", 4, "ngIf"], ["class", "text-smallest ml-auto", "ycnIcon", "", 3, "name", 4, "ngIf"], [4, "ngIf"], ["class", "dropdown-divider", 4, "ngIf"], [1, "custom-control-description", "dropdown-item-text"], [1, "dropdown-item-descr", 3, "textContent"], [1, "custom-control-description", 3, "ngClass", "textContent"], ["ycnIcon", "", 1, "text-smallest", "ml-auto", 3, "name"], [1, "help-toggler", 3, "click"]], template: function MultiSelectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2, 0)(2, "a", 3);
        i0.ɵɵlistener("click", function MultiSelectDropdownComponent_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggle()); });
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵtemplate(4, MultiSelectDropdownComponent_span_4_Template, 2, 4, "span", 4)(5, MultiSelectDropdownComponent_span_5_Template, 3, 1, "span", 5)(6, MultiSelectDropdownComponent_span_6_Template, 2, 1, "span", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵtemplate(8, MultiSelectDropdownComponent_div_8_Template, 10, 12, "div", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(9, "ycn-help-modal", null, 1);
    } if (rf & 2) {
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("dropdown ", ctx.dropdownContainerClass));
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c1, ctx.isOpen));
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("", ctx.buttonClass, " dropdown-toggle user-select-none"));
        i0.ɵɵproperty("disabled", !!ctx.inputDisabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.configCopy == null ? null : ctx.configCopy.title == null ? null : ctx.configCopy.title.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.configCopy == null ? null : ctx.configCopy.title == null ? null : ctx.configCopy.title.value);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.configCopy == null ? null : ctx.configCopy.showCount);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("dropdown-menu ", ctx.dropdownClass));
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c1, ctx.isOpen));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.configCopy.list);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.DisabledDirective, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgModel, i5.HelpModalComponent, i6.IconDirective], encapsulation: 2 });
